import { render, staticRenderFns } from "./RelatorioProduto.vue?vue&type=template&id=135f85e4"
import script from "./RelatorioProduto.vue?vue&type=script&lang=js"
export * from "./RelatorioProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports